import { GlobalProjectsMenuService } from '@core/services/global-projects-menu';
import { NavbarItemsProvider } from '@core/services/navbar-items/navbar-items';
import { AngularLayout } from '@rhtml/modifiers';
import { Inject } from '@rxdi/core';
import { async, Component, css, html, LitElement, styleMap } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';
import { Nav } from '@rxdi/ui-kit/nav';
import { SocialService } from '@stradivario/graphql-server';
import * as firebase from 'firebase/app';
import { filter, map, take } from 'rxjs/operators';
import { success } from 'toastr';

import { isDevelopment } from './environment';

/**
 * @customElement app-component
 */
@Component({
  selector: 'app-component',
  modifiers: [...AngularLayout],
  style: css`
    navbar-component {
      position: fixed;
      top: 0px;
      background: var(--global-background, '#24292f');
      width: 100%;
      z-index: 11;
    }
    .container {
      transition: 0.5s;
      width: 100%;
    }

    .sidebar {
      width: 100px;
    }
    .sidebar-button {
      padding: 5px;
      text-align: left;
      cursor: pointer;
      user-select: none;
      text-align: center;
      border-top: 1px solid rgba(255, 255, 255, 0.2);
    }
    .sidebar-button:hover {
      background: white;
      color: black;
    }
    @media (min-width: 1280px) {
      .sidebar {
        width: 150px;
      }

      .sidebar-button:hover {
        background: rgba(255, 255, 255, 0.5);
      }
    }
    .flex {
      display: flex;
    }

    @media (max-width: 740px) {
      .flex {
        display: block;
      }

      .menus {
        margin-bottom: 30px;
      }
    }

    .menus {
      color: black;
    }
  `,
  template(this: AppComponent) {
    return html`
      <div
        style=${styleMap({
          //  'min-height': `${window.innerHeight}px`,
          'margin-top': '66px',
        })}
      >
        <div class="container">
          <navbar-component slot="header"></navbar-component>
          <div class="flex ">
            ${async(
              this.navbarItemsProvider.getMenus().pipe(
                map(
                  (menus) => html`
                    <div class="menus">
                      <tabs-component
                        .bgColor=${'#f8fcff'}
                        .menus=${menus.map((menu) => ({
                          ...menu,
                          active: true,
                        }))}
                      ></tabs-component>
                    </div>
                  `
                )
              )
            )}

            <div style="width: 100%;">
              <router-outlet
                @onRouterLoaded=${(e) => {
                  this.router.onSnapshotChange().subscribe(() => {
                    if (window.location.href.includes('/projects/')) {
                      this.globalProjectsMenu.openMenu();
                    } else {
                      this.globalProjectsMenu.closeMenu();
                    }
                    this.navbarItemsProvider.setMenus([]);
                    document.body.scrollTop = 0; // For Safari
                    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                  });
                }}
              >
              </router-outlet>
            </div>
          </div>

          <footer-component slot="footer"></footer-component>
        </div>
        <div ngIf=${isDevelopment()}>
          <a
            @click=${async () => {
              const el = document.createElement('input');
              const user = firebase.auth().currentUser;
              el.value = JSON.stringify({
                Authorization: await user.getIdToken(),
              });
              this.shadowRoot.appendChild(el);
              await this.requestUpdate();
              el.select();
              document.execCommand('copy');
              this.shadowRoot.removeChild(el);
              success(`CLI Token copied to clipboard`);
            }}
            style="position: fixed; left: 0; bottom: 0; background-color: green; padding: 10px; cursor: pointer; z-index: 10000"
          >
            Copy Token
          </a>
        </div>
      </div>
    `;
  },
})
export class AppComponent extends LitElement {
  @Inject(Nav)
  private nav: Nav;

  @Router()
  router: Router;

  @Inject(SocialService)
  private socialService: SocialService;
  @Inject(GlobalProjectsMenuService)
  private globalProjectsMenu: GlobalProjectsMenuService;
  @Inject(NavbarItemsProvider)
  private navbarItemsProvider: NavbarItemsProvider;

  OnUpdateFirst() {
    this.socialService.isLoggedIn
      .pipe(
        filter((isLoggedIn) => !!isLoggedIn),
        filter(() => !!localStorage.getItem('redirectUrl')),
        take(1)
      )
      .subscribe(() => {
        this.router.go(localStorage.getItem('redirectUrl'));
        localStorage.removeItem('redirectUrl');
      });

    setTimeout(() => {
      const loader = document.querySelector('#loader');
      loader?.remove();
    }, 0);
  }
}
